var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "green-fitout green-fitout-comments" }, [
    _c(
      "div",
      { staticClass: "green-fitout__body" },
      [
        _vm.isHKlandUser
          ? [
              _c("HKLLeftRight", [
                _c(
                  "div",
                  { staticClass: "green-fitout-comments__title font-bold" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("tenantProjects.greenFitOut.titleReview")
                        ) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.isUnderReview
                  ? _c(
                      "div",
                      { staticClass: "green-fitout-comments__review-status" },
                      [
                        !_vm.isCurrentReviewer && _vm.canViewContent
                          ? _c("HKLGrayHint", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "tenantProjects.greenFitOut.underReviewBy",
                                      [_vm.currentReviewer.displayName]
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.lastReviewedBy && _vm.canViewContent
                          ? _c("HKLGrayHint", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "tenantProjects.greenFitOut.lastReviewedBy",
                                      [
                                        _vm.lastReviewedBy.displayName,
                                        _vm.lastReviewedBy.createdAt,
                                      ]
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.canViewContent || _vm.shouldShowTips
                          ? _c("HKLGrayHint", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "tenantProjects.submission.startedOn",
                                      [_vm.underReviewStartOn]
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.canViewPoint
                ? _c(
                    "div",
                    { staticClass: "green-fitout-comments__title font-bold" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("tenantProjects.greenFitOut.totalPoints", [
                              _vm.noHasPoint
                                ? _vm.$t("emptyValue")
                                : _vm.totalPoints,
                            ])
                          ) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.shouldShowTips
                ? _c("div", { staticClass: "row align-center" }, [
                    _c("div", { staticClass: "tip" }, [
                      _c(
                        "span",
                        { staticClass: "tip__text only-read" },
                        [
                          _vm.isUnderReview
                            ? [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "tenantProjects.greenFitOut.underReviewBy",
                                        [_vm.currentReviewer.displayName]
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            : [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "tenantProjects.greenFitOut.noStartLetter"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ],
                        ],
                        2
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row align-center" },
                [
                  _vm.canViewContent
                    ? [
                        !_vm.isUnderReview &&
                        !_vm.isCompleted &&
                        _vm.canCommentOnGreenFitout
                          ? _c(
                              "HKLButton",
                              {
                                attrs: {
                                  color: "darkblue",
                                  disabled: _vm.disableStartBtn,
                                },
                                on: { click: _vm.startLetter },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "tenantProjects.greenFitOut.startLetter"
                                      )
                                    ) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isUnderReview
                          ? [
                              _vm.isPaneActivated &&
                              _vm.isCurrentReviewer &&
                              _vm.canCommentOnGreenFitout
                                ? _c("DescriptionTinymceEditor", {
                                    staticClass:
                                      "green-fitout-comments_description-input",
                                    model: {
                                      value:
                                        _vm.currentGreenFitout.comments
                                          .description,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.currentGreenFitout.comments,
                                          "description",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "currentGreenFitout.comments.description",
                                    },
                                  })
                                : _c("p", {
                                    staticClass:
                                      "green-fitout-comments_description-input-display",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.currentGreenFitout.comments
                                          .description
                                      ),
                                    },
                                  }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "green-fitout-comments__attachments",
                                },
                                [
                                  _vm.isCurrentReviewer &&
                                  _vm.canCommentOnGreenFitout
                                    ? _c("HkldDropzone", {
                                        attrs: {
                                          sourceId: _vm.currentGreenFitout.id,
                                          metaData: { uploadOnTop: true },
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "TenantSubmissionDocuments",
                                    _vm._b(
                                      {},
                                      "TenantSubmissionDocuments",
                                      _vm.commentAttachmentAttrs,
                                      false
                                    )
                                  ),
                                ],
                                1
                              ),
                            ]
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ]
          : _vm._e(),
        _vm._v(" "),
        _c("GreenFitOutHistory"),
      ],
      2
    ),
    _vm._v(" "),
    _vm.isHKlandUser
      ? _c(
          "div",
          { staticClass: "on-hold-history" },
          [_c("GreenFitOutOnHoldHistory")],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }